import React from 'react';

/**
 * Componente reutilizable para mostrar una lista de usuarios con búsqueda.
 * @param {object} props
 * @param {string} props.title - Título de la lista (ej. "Usuarios Activos").
 * @param {Array} props.users - El array de usuarios a mostrar.
 * @param {string} props.searchTerm - El valor actual del input de búsqueda.
 * @param {function(React.ChangeEvent<HTMLInputElement>): void} props.onSearchChange - Handler para el cambio en la búsqueda.
 * @param {string|null} props.selectedUserId - El ID del usuario actualmente seleccionado.
 * @param {function(object): void} props.onSelectUser - Handler para cuando se hace clic en un usuario.
 * @param {function(object): React.ReactNode} [props.renderUserRole] - Función opcional para renderizar tags de rol.
 */
const UserList = ({ title, users, searchTerm, onSearchChange, selectedUserId, onSelectUser, renderUserRole }) => {
    return (
        <>
            <div className="user-list-header">
                <h3>{title} ({users.length})</h3>
                <input type="text" placeholder="Buscar por nombre o email..." className="search-input" value={searchTerm} onChange={onSearchChange} />
            </div>
            <div className="user-list-content">
                {users.length > 0 ? users.map(user => (
                    <div key={user.id} className={`user-card ${selectedUserId === user.id ? 'selected' : ''}`} onClick={() => onSelectUser(user)}>
                        <div className="user-avatar">{user.fullName?.charAt(0)?.toUpperCase() || 'U'}</div>
                        <div className="user-info">
                            <h4>{user.fullName || user.username || 'Usuario sin nombre'}</h4>
                            <p>{user.userEmail}</p>
                            {renderUserRole && renderUserRole(user)}
                        </div>
                    </div>
                )) : (
                    <p className="empty-state-text" style={{ padding: '1rem', margin: '1rem' }}>No se encontraron usuarios.</p>
                )}
            </div>
        </>
    );
};

export default UserList;